export default "__VITE_ASSET__BzT2CCj7__"